<!--能源优化成效（雷达图，柱状图）-->
<template>
<div class="er commonborder flex_row">
  <div id="er_radar1" class="echarts"></div>
  <div id="er_bar1" class="echarts"></div>
</div>

</template>

<script>
import api from '@/apis/power/power';
let echarts = require("echarts/lib/echarts");
export default {
  data() {
    return {
    };
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    //获取数据
    getList(){
      api.getIncome({year:''}).then(res=>{
        if(res.code==10000){
          let _data = res.data
          let _year = []
          let _num = []
          for(var i in _data){
            _year.push(_data[i].energyYear)
            _num.push(_data[i].fundIncom)
          }
          this.er_bar1(_year.reverse(),_num.reverse())
        }
      })
    },
    getListZB(){
      api.getIncomeZB().then(res=>{
        if(res.code==10000){
          let _data = res.data[0]
          this.er_radar1(
            _data.energyIncome,
            _data.safeIncome,
            _data.fundIncom,
            _data.socialIncome,
            _data.effIncome,
          )
        }
      })
    },
    er_radar1(a1,a2,a3,a4,a5){
      let _arr = [a1,a2,a3,a4,a5];
      let _max = Math.max(..._arr)
      let er_radar1 = echarts.init( document.getElementById('er_radar1') );
      er_radar1.setOption({
          tooltip: {
              position: [20,20],
              textStyle:{fontSize: this.$echartsFontSize},
          },
          radar: [
          {
              indicator:[
                { name: '单位能耗降低',max:_max},
                { name: '安全',max:_max},
                { name: '资金',max:_max},
                { name: '社会价值',max:_max},
                { name: '成效',max:_max},
              ],
              center: ['50%','55%'], //中心点位置
              radius: '65%', //大小
              splitNumber: 5, //网线条
              shape: "polygon", //多边形，circle圆形
              name: {
              //文字样式
                formatter: "{value}",
                fontSize: this.$echartsFontSize,
                textStyle: { color: "#ccd0f2" }
              },nameGap:8,
              splitArea: {
                areaStyle: {
                    color: [
                    "rgba(0, 204, 255, .6)",
                    "rgba(0, 204, 255, .5)",
                    "rgba(0, 204, 255, .4)",
                    "rgba(0, 204, 255, .3)",
                    "rgba(0, 204, 255, .2)",
                    "rgba(0, 204, 255,0)"
                    ] //大圆背景
                }
              },
              axisLine: {
                lineStyle: {
                    color: "rgba(0, 204, 255, .5)" //线条颜色
                }
              },
              splitLine: {
                lineStyle: {
                    color: "rgba(0, 204, 255, 1)" //圆圈线条颜色
                }
              }
          }
          ],
          series: [
            {
                name:'成效值',
                type: "radar",
                data: [{
                    value: [a1,a2,a3,a4,a5],
                    symbol: "rect",
                    symbolSize: 0,
                    areaStyle: {
                      normal: {
                          color: "rgba(255, 244, 92, 0.5)"
                      }
                    },
                    lineStyle: {
                      normal: {
                          color: "#ff0",
                          width: 3
                      }
                    }
                }]
            }
          ] 
      })
    },
    er_bar1(a,b){
      let er_bar1 = echarts.init( document.getElementById('er_bar1') );
      er_bar1.setOption({
          color:['#ffea04'],
          tooltip: { 
            trigger: 'axis',
            textStyle:{fontSize: this.$echartsFontSize},
            formatter:(params)=>{
              return params[0].name + '<br />'+params[0].marker + ' 总成效：'+ this.$common.formatNum(params[0].value) + ' 万元';
            },
          },
          xAxis: {
            type: 'category',
            axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
            axisLine: { lineStyle: { color:this.axisLineColor } },
            axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
            data: a,
              
          },
          yAxis: {
            name: "万元",
            type: "value",
            nameGap:this.$echartsFontSize-7,
            nameTextStyle: {   //  单位样式
              color: this.axisLabelColor,    //  字体颜色
              fontSize: this.$echartsFontSize-2, 	//  字体大小
              padding: [0,15,4,0]		//  内填充
            },
            axisLabel: { color: this.axisLabelColor, fontSize: this.$echartsFontSize },
            axisLine: { lineStyle: { color: this.axisLineColor } },
            splitLine: { lineStyle: this.splitLineStyle},
            splitNumber: 5,
          },
          grid: { left: '5%',right:'8%',top:'25%',bottom:'4%',containLabel: true},
          series: [
            {
              type: 'bar',
              barWidth:this.$echartsFontSize,
              data: b,
              label: {
                  show: false,
                  position: 'top',
                  textStyle:{ color:'#fff',fontSize:this.$echartsFontSize},
                  formatter: "{c}"+"万元",
              },
            } 
          ]
      })
      this.$common.moveEcharts(b.length,er_bar1)
    },
  },
  mounted() {
    this.getList()
    this.getListZB()
  },
};
</script>

<style lang="less" scoped>
.er{
  #er_radar1{ height: 100%; width: 40%;}
  #er_bar1{ height: 100%; width: 60%; position: relative;}
  #er_bar1::before{ content: '历年总成效'; position: absolute; top:0.2rem; left:0; font-size: .725rem; color:#00ccff;}
}
</style>